import { DATE_FORMAT, formatDate, getLoanById, patchSetNieData } from '@nemuru-eng/js-api-client';

import { NieDataFormType } from '@/components/modules/KYC/KYCLoan/BorrowerKYC/components/DocumentIdSection/schemas/nieDataForm.schema';
import { useCache } from '@/hooks/requests/useCache';
import { useRequest } from '@/hooks/requests/useRequest';

interface UseUpdateNieDataProps {
  loanId: string;
  onboardingDetailsId: string;
}

export const useUpdateNieData = ({ loanId, onboardingDetailsId }: UseUpdateNieDataProps) => {
  const { revalidate: revalidateLoan } = useCache(getLoanById, { loanId });
  const { request, loading: requestLoading } = useRequest();

  const patchNieData = async (nieData: NieDataFormType) => {
    await request(patchSetNieData, {
      id: onboardingDetailsId,
      nieData: {
        nationalityPeriod: nieData.nationalityPeriod,
        cardId: nieData.cardId,
        expirationDateCard: formatDate(nieData.expirationDateCard, DATE_FORMAT.YYYY_MM_DD),
        socialSecurityDate: formatDate(nieData.socialSecurityDate, DATE_FORMAT.YYYY_MM_DD),
        numberOfWork: nieData.numberOfWork,
      },
    });
    revalidateLoan();
  };

  return { patchNieData, requestLoading };
};
